/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:postVenditaDefinizione
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var PostVenditaDefinizioneCtrl = function (
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    uiGridConstants,
    labelSrvc,
    loggerSrvc,
    messaggiFctr,
    postVenditaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.loggerSrvc = loggerSrvc;
    this.postVenditaCartaDebitoIntSrvc = postVenditaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Numero della carta recuperato da chiamata
     */
    this.numeroCarta;

    /**
     * Array delle funzioni filtrato in base alla selezione della carta
     */
    this.elencoFunzioniFiltrato = [];

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.postVenditaCartaDebitoIntSrvc.spinner;

    /**
     * Definizione della griglia dei conti corrente
     */
    this.carteGridOptions = {};

    /**
     * Altezza della griglia dei conti corrente
     */
    this.altezzaTabellaCarte = 0;

    /**
     * Altezza di una riga della griglia dei conti corrente
     */
    this.altezzaRigaCarte = 30;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prosegui
     */
    this.postVenditaCartaDebitoIntSrvc.proseguiVisibile = function () {
      // Per ora prosegui esiste solo per la funzione di blocco
      return (
        (!self.postVenditaCartaDebitoIntSrvc.currentFunzione ||
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === 'APLBLC' ||
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === 'MODCNT' ||
          self.postVenditaCartaDebitoIntSrvc.currentFunzione === 'MODIND') &&
        !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly()
      );
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone indietro
     */
    this.postVenditaCartaDebitoIntSrvc.indietroVisibile = function () {
      return false;
    };

    /**
     * implementazione del completa.
     */
    this.postVenditaCartaDebitoIntSrvc.completaVisibile = function () {
      // Per ora tutte le funzioni hanno 1 step tranne blocco
      return (
        self.postVenditaCartaDebitoIntSrvc.currentFunzione &&
        self.postVenditaCartaDebitoIntSrvc.currentFunzione !== 'APLBLC' &&
        self.postVenditaCartaDebitoIntSrvc.currentFunzione !== 'MODCNT' &&
        self.postVenditaCartaDebitoIntSrvc.currentFunzione !== 'MODIND'
      );
    };

    /**
     * Implementazione nel service della funzione di abilitazione indetro
     */
    this.postVenditaCartaDebitoIntSrvc.indietroAbilitato = function () {
      return false;
    };

    /**
     * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
     */
    this.postVenditaCartaDebitoIntSrvc.proseguiAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di abilitazione completa pratica
     */
    this.postVenditaCartaDebitoIntSrvc.completaAbilitato = function () {
      return self.formValido();
    };

    /**
     * Verifica se i dati inseriti nel form sono validi
     */
    this.formValido = function () {
      return !!self.postVenditaCartaDebitoIntSrvc.currentFunzione && !!self.postVenditaCartaDebitoIntSrvc.currentCarta;
    };

    /**
     * Funzione che nel caso di specializzazione pratica non light recupera i conti corrente della persona giuridica
     * collegata alla pratica
     */
    this.loadElencoCarteGrid = function () {
      const defAltezzaTabellaCarte = 5;

      if (self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte.length > defAltezzaTabellaCarte)
        self.altezzaTabellaCarte = defAltezzaTabellaCarte * self.altezzaRigaCarte + 40;
      else
        self.altezzaTabellaCarte =
          self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte.length * self.altezzaRigaCarte + 40;

      if (self.numeroCarta) {
        var cardSearch = self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte.filter(function (carta) {
          return carta.numeroCarta === self.numeroCarta;
        });
        if (cardSearch.length > 0) {
          self.postVenditaCartaDebitoIntSrvc.currentCarta = cardSearch[0];
        }
      }

      self.carteGridOptions = {
        enableSorting: !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly(),
        enableColumnMenus: false,
        enableGrouping: false,
        multiSelect: false,
        showHeader: true,
        enableRowHeaderSelection: false,
        enableRowSelection: !self.postVenditaCartaDebitoIntSrvc.praticaIsReadOnly(),
        showGridFooter: false,
        enableVerticalScrollbar: self.uiGridConstants.scrollbars.WHEN_NEEDED,
        enableHorizontalScrollbar: self.uiGridConstants.scrollbars.WHEN_NEEDED,
        enableColumnResizing: true,
        columnDefs: [
          {
            displayName: $scope.msg('label.definizione.postvendita.carta'),
            field: 'numeroCarta',
            width: '15%',
            name: 'numeroCarta'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.scadenza'),
            field: 'dataScadenza',
            width: '10%',
            name: 'dataScadenza',
            type: 'date',
            cellFilter: "date:'dd/MM/yyyy'"
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.stato'),
            field: 'stato',
            width: '10%',
            name: 'stato'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.descrizione'),
            field: 'descrizione',
            width: '10%',
            name: 'descrizione'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.conto'),
            field: 'conto',
            width: '10%',
            name: 'conto'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.intestatario'),
            field: 'intestazione',
            width: '15%',
            name: 'intestazione'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.ndgtitolare'),
            field: 'ndg',
            width: '10%',
            name: 'ndg'
          },
          {
            displayName: $scope.msg('label.definizione.postvendita.indirizzo'),
            field: 'indirizzoCompleto',
            width: '40%',
            name: 'indirizzoCompleto'
          }
        ],
        data: self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte,
        onRegisterApi: function (gridApi) {
          gridApi.grid.modifyRows(self.carteGridOptions.data);

          // Se era già stato salvato la carta la recupero e seleziono
          if (self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte && self.postVenditaCartaDebitoIntSrvc.currentCarta) {
            angular.forEach(self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte, function (carta, index) {
              if (carta.numeroCarta === self.postVenditaCartaDebitoIntSrvc.currentCarta.numeroCarta) {
                gridApi.selection.selectRow(self.postVenditaCartaDebitoIntSrvc.elencoCarte.carte[index]);
              }
            });
          }

          gridApi.selection.on.rowSelectionChanged($scope, function (row) {
            self.selezionaCarta(row);
          });
        }
      };
    };

    // private function
    function loadSpinnerAndLog(logmessage) {
      self.spinner.showSpinner++;

      self.loggerSrvc.log('postVenditaDefinizioneCtrl', self.loggerSrvc.INFO, logmessage);
    }

    this.recuperaElencoCarte = function (ndg) {
      if (!!self.postVenditaCartaDebitoIntSrvc.elencoCarte) {
        self.loadElencoCarteGrid();
      } else {
        // logging
        loadSpinnerAndLog('recupero Carte per NDG ' + ndg);
        // call service per elencoCarte
        self.postVenditaCartaDebitoIntSrvc
          .promiseElencoCarte(ndg)
          .then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response)) {
                return;
              }
              self.postVenditaCartaDebitoIntSrvc.elencoCarte = response.data.result;

              self.postVenditaCartaDebitoIntSrvc.anagrafica = response.data.result.anagrafica;

              self.loggerSrvc.log(
                'PostVenditaCartaDebitoIntCtrl',
                self.loggerSrvc.INFO,
                'recuperate con successo carte per ndg ' + ndg
              );

              self.loadElencoCarteGrid();
            },
            function (reason) {
              self.messaggiFctr.processaResponse(reason);
              self.loggerSrvc.log(
                'PostVenditaCartaDebitoIntCtrl',
                self.loggerSrvc.SEVERE,
                'Errore durante la creazione della per NDG ' +
                  ndg +
                  ' e Prodotto ' +
                  self.idProdotto +
                  ': ' +
                  self.loggerSrvc.formattaMessaggio(reason)
              );
            }
          )
          .finally(function () {
            if (self.spinner.showSpinner > 0) {
              self.spinner.showSpinner--;
            }
          });
      }
    };

    /**
     * Funzione chiamata al cambio di funzione selezionata
     */
    this.onFunzioneChange = function () {
      $scope.$emit('onFunzioneChange');
    };

    /**
     * Funzione assegnata alla selezione di una riga di utenze
     * @param carta Carta selezionata nella tabella
     */
    this.selezionaCarta = function (carta) {
      // Reset della funzione selezionata se cambio lo stato
      // Non ha senso senza i filtri, decommentare in caso di reintroduzione dei filtri
      // if (
      //   self.postVenditaCartaDebitoIntSrvc.currentCarta &&
      //   self.postVenditaCartaDebitoIntSrvc.currentCarta.stato !== carta.entity.stato
      // ) {
      //   self.postVenditaCartaDebitoIntSrvc.currentFunzione = '';
      // }
      // Se ho selezionato qualcosa imposto currentCarta e filtro le funzioni
      if (carta.isSelected) {
        self.postVenditaCartaDebitoIntSrvc.currentCarta = carta.entity;
        // Nota: i filtri lato FE sono stati annullati per ora, decommentare il codice sottostante per
        // reinserirli

        // var filter = self.getFiltroFunzioni(carta.entity.stato);
        // // Se filter è popolato allora lo usa per filtrare, altrimenti imposta lista vuota
        // if (filter) {
        //   self.elencoFunzioniFiltrato = self.postVenditaCartaDebitoIntSrvc.elencoFunzioni.filter(function (funzione) {
        //     return funzione.codice === filter;
        //   });
        // } else {
        //   self.elencoFunzioniFiltrato = [];
        // }
      } else {
        // Se non ho selezionato nessuna carta imposto currentCarta a null e ripristino l'elenco funzioni
        // a quello originale completo
        self.postVenditaCartaDebitoIntSrvc.currentCarta = null;
        // Decommenta per reinserire i filtri
        // self.elencoFunzioniFiltrato = self.postVenditaCartaDebitoIntSrvc.elencoFunzioni;
      }
    };

    /**
     * Passando lo stato di una carta restituisce il filtro da applicare all'elenco funzioni
     * @param stato Stato della carta per cui filtrare
     */
    this.getFiltroFunzioni = function (stato) {
      var filter = '';
      switch (stato) {
        // Bloccata
        case 'BL':
          filter = 'RMZBLC';
          break;
        // Attiva
        case 'AT':
          filter = 'APLBLC';
          break;
        // Codice non trovato
        default:
          filter = '';
      }
      return filter;
    };

    /**
     * Recupera i dati aggiuntivi (ndg utilizzatore e numero rapporto)
     */
    this.recuperaFunzioni = function () {
      // logging
      loadSpinnerAndLog('recupero funzioni NDG ');
      self.postVenditaCartaDebitoIntSrvc
        .promiseRecuperaFunzioni()
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            self.postVenditaCartaDebitoIntSrvc.elencoFunzioni = response.data.result;
            self.elencoFunzioniFiltrato = self.postVenditaCartaDebitoIntSrvc.elencoFunzioni;

            self.loggerSrvc.log('PostVenditaCartaDebitoIntCtrl', self.loggerSrvc.INFO, 'Recupero delle funzioni ');
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.loggerSrvc.log(
              'PostVenditaCartaDebitoIntCtrl',
              self.loggerSrvc.SEVERE,
              'Errore durante il recupero funzioni per NDG ' +
                self.ndg +
                ': ' +
                self.loggerSrvc.formattaMessaggio(reason)
            );
          }
        )
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi = {
          indirizzoSpedizione: {
            via: null,
            numero: null,
            provincia: null,
            comune: {
              valore: null
            },
            cap: null,
            nazione: null,
            localita: null
          }
        };

        self.postVenditaCartaDebitoIntSrvc.idPratica = self.$stateParams.idPratica;
        if (self.postVenditaCartaDebitoIntSrvc.idPratica) {
          self.spinner.showSpinner++;
          self.postVenditaCartaDebitoIntSrvc
            .promiseRecuperaDati(self.postVenditaCartaDebitoIntSrvc.idPratica)
            .then(function (response) {
              if (response && response.data && response.data.result) {
                self.postVenditaCartaDebitoIntSrvc.currentFunzione = response.data.result.funzione;
                self.numeroCarta = response.data.result.numeroCarta;
                self.postVenditaCartaDebitoIntSrvc.currentBlocco = response.data.result.tipoBlocco;
                self.postVenditaCartaDebitoIntSrvc.currentIban = response.data.result.iban;

                self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi = {
                  indirizzoSpedizione: {
                    via: null,
                    numero: null,
                    provincia: null,
                    comune: {
                      valore: null
                    },
                    cap: null,
                    nazione: null,
                    localita: null
                  }
                };

                self.postVenditaCartaDebitoIntSrvc.datiAggiuntivi.indirizzoSpedizione =
                  response.data.result.indirizzoSpedizione;

                self.postVenditaCartaDebitoIntSrvc.datiPratica = {
                  stato: response.data.result.proposta.stato,
                  step: response.data.result.proposta.step
                };

                // load delle carte.
                self.recuperaElencoCarte(self.postVenditaCartaDebitoIntSrvc.ndg);

                if (self.postVenditaCartaDebitoIntSrvc.currentFunzione) {
                  self.onFunzioneChange();
                }
              }
            })
            .finally(function () {
              if (self.spinner.showSpinner > 0) {
                self.spinner.showSpinner--;
              }
            });
        }else{
        	// load delle carte.
            self.recuperaElencoCarte(self.postVenditaCartaDebitoIntSrvc.ndg);
        }

        // carico le funzioni attraverso il servizio.
        self.recuperaFunzioni();
      });
    };

    self.init();
  };

  PostVenditaDefinizioneCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'uiGridConstants',
    'CdintLabelSrvc',
    'CdintLoggerSrvc',
    'CdintMessaggiFctr',
    'PostVenditaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'postVenditaCartaDebitoInt/postVenditaDefinizione/postVenditaDefinizione.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var PostVenditaDefinizioneComponent = {
    controller: PostVenditaDefinizioneCtrl,
    controllerAs: 'postVenditaDefinizioneCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('postVenditaDefinizione', PostVenditaDefinizioneComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/postVenditaCartaDebitoInt/postVenditaDefinizione/postVenditaDefinizione.cmpt.js
// module id = 21
// module chunks = 0